<template>
  <div
    class="container page-layout"
    :class="{ fixed: isFixed, 'full-height': hasFullHeight }"
  >
    <header class="mt-4 pl-0 ml-0">
      <slot name="header"></slot>
    </header>
    <main>
      <slot name="main"></slot>
    </main>
  </div>
</template>

<script>
export default {
  props: ['isFixed', 'hasFullHeight'],
}
</script>

<style scoped lang="scss">
.page-layout {
  padding-left: 40px;
  padding-right: 35px;
  display: flex;
  flex-direction: column;
  max-width: 1200px;

  &.fixed {
    height: calc(100vh - 50px);

    main {
      height: 100%;
      overflow: hidden;
    }

    header {
      display: flex;
      padding-bottom: 10px;
    }
  }

  &.full-height {
    height: 100%;

    main {
      height: 100%;
      overflow: hidden;
    }

    header {
      display: flex;
      padding-bottom: 10px;
    }
  }
}

/* Mediun Devices ( 991.98px ) */
@media (max-width: 991.98px) {
  header {
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .page-layout {
    padding-left: 0px;
    padding-right: 0px;

    .nav-item a {
      margin-bottom: 0px !important;
      margin-top: 0px !important;
    }

    .header.nav {
      padding-left: 10px;
      padding-right: 0px;
    }

    &.fixed {
      height: 100%;
    }
  }
}
</style>
